export default {
  //uiBaseUrl: "https://www.iwsa.com.tr",
  //apiBaseUrl: "https://api.iwsa.com.tr",
  //dashboardBaseUrl: "https://dashboard.iwsa.com.tr",

  uiBaseUrl: 'http://ui.iwsa.limeorlemon.com',
  apiBaseUrl: 'http://api.iwsa.limeorlemon.com',
  dashboardBaseUrl: 'http://dashboard.iwsa.limeorlemon.com'

  //uiBaseUrl: 'http://preprod.ui.iwsa.limeorlemon.com',
  //apiBaseUrl: 'http://preprod.api.iwsa.limeorlemon.com',
  //dashboardBaseUrl: 'http://preprod.dashboard.iwsa.limeorlemon.com'
};
